// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyInboxDownloadFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.75 2.167h.5a.5.5 0 0 1 .5.5v7.347l2.38-2.083a.5.5 0 0 1 .705.047l.33.377a.5.5 0 0 1-.047.705l-3.789 3.315a.5.5 0 0 1-.658 0L7.882 9.06a.5.5 0 0 1-.047-.705l.33-.377a.5.5 0 0 1 .705-.047l2.38 2.083V2.667a.5.5 0 0 1 .5-.5zM10 5.5v1a.5.5 0 0 1-.5.5H6.978a1 1 0 0 0-.919.606L4.176 12H9.5a.5.5 0 0 1 .5.5v.5c0 .729.263 1.202.602 1.503.357.317.861.497 1.398.497.537 0 1.041-.18 1.398-.497.339-.302.602-.775.602-1.503v-.5a.5.5 0 0 1 .5-.5h5.324l-1.883-4.394a1 1 0 0 0-.92-.606H14.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2.522a3 3 0 0 1 2.757 1.818l1.978 4.616c.16.373.243.775.243 1.182V18a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-5.384a3 3 0 0 1 .243-1.182L4.22 6.818A3 3 0 0 1 6.978 5H9.5a.5.5 0 0 1 .5.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyInboxDownloadFilled;
